import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import accessibility from "../../../Assets/Projects/GIS/Scoring.png";
import accessibility2 from "../../../Assets/Projects/GIS/Scoring2.png";
import accessibility3 from "../../../Assets/Projects/GIS/Scoring3.png";
import accessibility4 from "../../../Assets/Projects/GIS/Scoring4.png";
import accessibility5 from "../../../Assets/Projects/GIS/Scoring5.png";
import accessibility6 from "../../../Assets/Projects/GIS/Scoring6.png";
import accessibility7 from "../../../Assets/Projects/GIS/Scoring7.png";

function AccessibilityAnalysis() {
  return (
    <ProjectDetailCard
      title="GIS-Based Accessibility Analysis for Healthcare and Education Services"
      image={accessibility}
      screenshots={[accessibility2, accessibility3, accessibility4]}
      description="
      GIS-Based Accessibility Analysis for Healthcare and Education Services is a spatial analysis application developed to evaluate the accessibility of public facilities in Kampung Mesjid, North Labuhanbatu Regency. The system applies a GIS-based scoring method to measure the level of accessibility to healthcare and educational facilities by considering multiple spatial factors such as distance, road networks, and service coverage. The results are visualized through interactive maps and thematic analyses, providing valuable insights for regional planning and supporting data-driven decision-making in public service development.
      "
      technologies={[
        "ArcGIS",
        "ArcGIS Pro",
        "Spatial Analysis",
        "GIS",
        "Scoring Method",
        "Digital Mapping",
        "Microsoft Excel",
        "Data Analysis",
        "Cartography",
        "Git",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={accessibility5} alt="gallery1" />
          <img src={accessibility6} alt="gallery2" />
          <img src={accessibility7} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default AccessibilityAnalysis;
